import { useSettings } from "master";

export const useFaq = ({ load = false, key = "" }) => {
  const { settingsInfo } = useSettings({ load, key });
  return {
    settingsInfo,
  };
};
